import { useEffect } from "react";
import { Modal, Form } from "antd";
import PlanFormFields, { buildPlanPayload, planToFormValues } from "./PlanFormFields";

const EditSubscriptionPlanModal = ({ visible, loading, plan, metadata, onSubmit, onClose }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && plan) {
            form.setFieldsValue(planToFormValues(plan));
        }
    }, [visible, plan, form]);

    const handleFinish = (values) => {
        onSubmit(buildPlanPayload(values));
    };

    const handleAfterClose = () => {
        form.resetFields();
    };

    return (
        <Modal
            title={`Edit Plan: ${plan?.name || ""}`}
            open={visible}
            onCancel={onClose}
            onOk={() => form.submit()}
            confirmLoading={loading}
            width={800}
            afterClose={handleAfterClose}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <PlanFormFields form={form} metadata={metadata} />
            </Form>
        </Modal>
    );
};

export default EditSubscriptionPlanModal;
